import shajs from 'sha.js';
import * as CryptoJS from 'crypto-js';

const Encryptionkey = process.env.REACT_APP_ENCRYPTION_KEY || 'aGgRTenEUgoACtcOAr';
const Decryptionkey = process.env.REACT_APP_DECRYPTION_KEY || 'AecECroRUgnGTa';

const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_IV || 'globalaesvectors');

export function Encrypt(InputString: any) {
    const hashstring = shajs('sha256').update(Encryptionkey).digest('hex');
    const hashsubstring = hashstring.substring(0, 32);
    const Enckey = CryptoJS.enc.Utf8.parse(hashsubstring);

    let Encrypted: any = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(InputString),
        Enckey,
        {
            keySize: 128 / 8,
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );
    Encrypted = Encrypted.ciphertext.toString(CryptoJS.enc.Base64);

    Encrypted = Encrypted.split('+').join('-');
    Encrypted = Encrypted.split('/').join('_');
    return Encrypted;
}

export function Decrypt(InputString: any) {
    // console.log("CRYPTO DEBUG: InputString type:", typeof InputString);
    // console.log("CRYPTO DEBUG: InputString value:", InputString);

    if (!InputString) return null;

    // Handle case where payload is already an object (interceptor didn't decrypt but axios parsed it)
    if (typeof InputString === 'object') return InputString;

    // Try parsing as plain JSON first (in case endpoint returns unencrypted string)
    try {
        // Cleaning the input string just in case
        const cleanedInput = InputString.trim();
        const parsed = JSON.parse(cleanedInput);
        if (parsed && typeof parsed === 'object') {
            return parsed;
        }
    } catch (e) {
        // Not plain JSON, continue to decrypt
        // console.debug("Not plain JSON:", e);
    }

    const hashstring = shajs('sha256').update(Decryptionkey).digest('hex');
    const hashsubstring = hashstring.substring(0, 32);
    const Enckey = CryptoJS.enc.Utf8.parse(hashsubstring);

    let Dencryptedinput = InputString.split('-').join('+');
    Dencryptedinput = Dencryptedinput.split('_').join('/');

    let Dencrypted: any = CryptoJS.AES.decrypt(Dencryptedinput, Enckey, {
        keySize: 128 / 8,
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    try {
        const decryptedStr = Dencrypted.toString(CryptoJS.enc.Utf8);
        console.log("CRYPTO DEBUG: Raw Decrypted String:", decryptedStr);
        if (!decryptedStr) {
            console.warn("Decryption produced empty string. Input might be unencrypted plain text or key is wrong.");
            return null;
        }
        const result = JSON.parse(decryptedStr);
        console.log("CRYPTO DEBUG: Parsed JSON:", result);
        return result;
    } catch (e) {
        console.error("Decryption or JSON parse failed", e);
        return null;
    }
}

// Keeping legacy exports for compatibility during refactor
export const encryptPayload = Encrypt;
export const decryptPayload = Decrypt;

export const decryptData = async (): Promise<void> => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, 2000); // Simulate 2 seconds of decryption work
    });
};
